import { format } from 'date-fns';
import { Eye } from 'lucide-react';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
  DialogTitle,
  DialogHeader,
  DialogDescription,
  DialogFooter,
  DialogClose,
} from '../../components/ui/dialog';
import { MonacoJsonEditor } from '../../components/ui/monaco-json-editor';
import { VorgangDetailProtokoll } from '../../types';

export const getSubStepItemForZwischenSpeicherung = (
  zwischenspeicherungen: VorgangDetailProtokoll[number],
) => {
  const datum = format(zwischenspeicherungen.date, "dd.MM.yyyy 'um' HH:mm:ss");
  const user = zwischenspeicherungen.user;
  const newPayload = JSON.stringify(
    zwischenspeicherungen.details.newPayload,
    null,
    2,
  );
  const previousPayload = JSON.stringify(
    zwischenspeicherungen.details.previousPayload,
    null,
    2,
  );

  return {
    date: new Date(zwischenspeicherungen.date),
    initiator: zwischenspeicherungen.user,
    title: 'Zwischenspeicherung',
    icon: (
      <Dialog>
        <form>
          <DialogTrigger asChild>
            <button
              className="ml-2 p-1 hover:bg-gray-200 rounded transition-colors cursor-pointer"
              title="Details anzeigen"
            >
              <Eye className="h-4 w-4" />
            </button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-[1200px]">
            <DialogHeader>
              <DialogTitle>Zwischenspeicherung</DialogTitle>
              <DialogDescription>
                <b>{user}</b> hat am {datum} die Daten geändert und gespeichert.
              </DialogDescription>
            </DialogHeader>
            <MonacoJsonEditor
              value={newPayload}
              previousValue={previousPayload}
              readOnly
            />
            <DialogFooter>
              <DialogClose asChild>
                <Button variant="outline">Schließen</Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </form>
      </Dialog>
    ),
  };
};
